export const bigIntJsonStringifyReplacer = (_: unknown, value: unknown) =>
  typeof value === 'bigint' ? value.toString(10) : value;

export const JSON_BIG_INT_PREFIX = 'BigInt:';

export const jsonSerializeBigInt = (_key: unknown, val: unknown) => {
  if (typeof val === 'bigint') {
    return `${JSON_BIG_INT_PREFIX}${val.toString(10)}`;
  }
  return val;
};

export const jsonDeserializeBigInt = (_key: unknown, val: unknown) => {
  if (typeof val === 'string' && val.startsWith(JSON_BIG_INT_PREFIX)) {
    return BigInt(val.replace(JSON_BIG_INT_PREFIX, ''));
  }
  return val;
};
